module.exports = __webpack_public_path__ + "img/zidongguanli.48842c61.png";